/**
 * B2B Landing Page — Utopia Beauty
 * Scroll animations, smooth anchor scrolling, stat counter animation
 */
(function() {
  'use strict';

  // --- Scroll-triggered fade-in animations ---
  if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    var fadeObserver = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('b2b-visible');
          fadeObserver.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.1,
      rootMargin: '0px 0px -40px 0px'
    });

    document.querySelectorAll('.b2b-fade-in').forEach(function(el) {
      fadeObserver.observe(el);
    });
  }

  // --- Smooth scroll for anchor links ---
  document.querySelectorAll('a[href^="#b2b-"]').forEach(function(link) {
    link.addEventListener('click', function(e) {
      var hash = this.getAttribute('href');
      var target = document.querySelector(hash);
      if (target) {
        e.preventDefault();
        var headerHeight = parseInt(
          getComputedStyle(document.documentElement).getPropertyValue('--sticky-header-height') || '0',
          10
        );
        var top = target.getBoundingClientRect().top + window.pageYOffset - headerHeight - 20;
        window.scrollTo({ top: top, behavior: 'smooth' });
      }
    });
  });

  // --- Stat counter animation ---
  var statObserver = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        animateCounter(entry.target);
        statObserver.unobserve(entry.target);
      }
    });
  }, { threshold: 0.5 });

  document.querySelectorAll('.b2b-stat-number').forEach(function(el) {
    statObserver.observe(el);
  });

  function animateCounter(el) {
    var text = el.textContent.trim();
    var match = text.match(/^([\d,]+)/);
    if (!match) return;

    var target = parseInt(match[1].replace(/,/g, ''), 10);
    var suffix = text.slice(match[1].length);
    var duration = 1200;
    var start = performance.now();

    function update(now) {
      var progress = Math.min((now - start) / duration, 1);
      var eased = 1 - Math.pow(1 - progress, 3);
      var current = Math.round(target * eased);
      el.textContent = current.toLocaleString() + suffix;
      if (progress < 1) requestAnimationFrame(update);
    }

    requestAnimationFrame(update);
  }

  // --- Application form submission ---
  var form = document.getElementById('b2b-application-form');
  if (form) {
    var submitBtn = form.querySelector('button[type="submit"]');
    var originalBtnText = submitBtn ? submitBtn.textContent : 'Submit Application';

    form.addEventListener('submit', function(e) {
      e.preventDefault();

      // Clear previous errors
      form.querySelectorAll('.b2b-input-error').forEach(function(el) {
        el.classList.remove('b2b-input-error');
      });
      form.querySelectorAll('.b2b-field-error').forEach(function(el) {
        el.remove();
      });
      var existingFormError = form.querySelector('.b2b-form-error');
      if (existingFormError) existingFormError.remove();

      // Validate required fields
      var requiredFields = form.querySelectorAll('[required]');
      var isValid = true;

      requiredFields.forEach(function(field) {
        if (!field.value.trim()) {
          isValid = false;
          field.classList.add('b2b-input-error');
          var errorMsg = document.createElement('div');
          errorMsg.className = 'b2b-field-error';
          errorMsg.textContent = 'This field is required';
          field.parentNode.appendChild(errorMsg);
        }
      });

      if (!isValid) return;

      // Disable button, show loading state
      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.textContent = 'Submitting...';
      }

      // Guard: don't submit if action URL is missing
      var actionUrl = form.getAttribute('action');
      if (!actionUrl || actionUrl === '#') {
        var errorDiv = document.createElement('div');
        errorDiv.className = 'b2b-form-error';
        errorDiv.textContent = 'Form submission is not configured. Please contact us directly.';
        var btnContainer = submitBtn ? submitBtn.parentNode : form;
        btnContainer.appendChild(errorDiv);
        if (submitBtn) {
          submitBtn.disabled = false;
          submitBtn.textContent = originalBtnText;
        }
        return;
      }

      // Hidden iframe submission (follows GAS 302 redirects properly)
      var iframeName = 'b2b-submit-iframe-' + Date.now();
      var iframe = document.createElement('iframe');
      iframe.name = iframeName;
      iframe.style.display = 'none';
      document.body.appendChild(iframe);

      // Point form at the hidden iframe
      form.target = iframeName;
      form.method = 'POST';

      var submitted = false;

      function onSuccess() {
        if (submitted) return;
        submitted = true;
        form.style.display = 'none';
        var successEl = document.getElementById('b2b-form-success');
        if (successEl) successEl.style.display = 'block';
        // Clean up
        setTimeout(function() {
          if (iframe.parentNode) iframe.parentNode.removeChild(iframe);
        }, 1000);
      }

      // iframe load = submission completed (GAS responded after redirect)
      iframe.addEventListener('load', onSuccess);

      // Submit the form into the hidden iframe
      form.submit();
    });
  }

  // --- Countdown timer (for [data-deadline] elements) ---
  document.querySelectorAll('[data-deadline]').forEach(function(el) {
    var deadline = new Date(el.getAttribute('data-deadline'));
    if (isNaN(deadline.getTime())) return;

    var timerId = null;

    function update() {
      var now = Date.now();
      var diff = deadline.getTime() - now;

      if (diff <= 0) {
        el.innerHTML = '<div class="b2b-countdown-closed">Applications closed</div>';
        if (timerId) clearInterval(timerId);
        return;
      }

      var days = Math.floor(diff / (1000 * 60 * 60 * 24));
      var hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      var minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
      var seconds = Math.floor((diff % (1000 * 60)) / 1000);

      var daysEl = el.querySelector('[data-unit="days"]');
      var hoursEl = el.querySelector('[data-unit="hours"]');
      var minutesEl = el.querySelector('[data-unit="minutes"]');
      var secondsEl = el.querySelector('[data-unit="seconds"]');
      if (daysEl) daysEl.textContent = days;
      if (hoursEl) hoursEl.textContent = ('0' + hours).slice(-2);
      if (minutesEl) minutesEl.textContent = ('0' + minutes).slice(-2);
      if (secondsEl) secondsEl.textContent = ('0' + seconds).slice(-2);
    }

    update();
    timerId = setInterval(update, 1000);
  });

  // --- Generic iframe form handler (used for lead magnet) ---
  function bindFormWithIframe(formEl, successElId) {
    if (!formEl) return;
    var submitBtn = formEl.querySelector('button[type="submit"]');
    var originalBtnText = submitBtn ? submitBtn.textContent : 'Submit';

    formEl.addEventListener('submit', function(e) {
      e.preventDefault();

      formEl.querySelectorAll('.b2b-input-error').forEach(function(el) { el.classList.remove('b2b-input-error'); });
      formEl.querySelectorAll('.b2b-field-error').forEach(function(el) { el.remove(); });
      var existingFormError = formEl.querySelector('.b2b-form-error');
      if (existingFormError) existingFormError.remove();

      var requiredFields = formEl.querySelectorAll('[required]');
      var isValid = true;
      requiredFields.forEach(function(field) {
        if (!field.value.trim()) {
          isValid = false;
          field.classList.add('b2b-input-error');
          var errorMsg = document.createElement('div');
          errorMsg.className = 'b2b-field-error';
          errorMsg.textContent = 'This field is required';
          field.parentNode.appendChild(errorMsg);
        }
      });
      if (!isValid) return;

      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.textContent = 'Submitting...';
      }

      var actionUrl = formEl.getAttribute('action');
      if (!actionUrl || actionUrl === '#') {
        var errorDiv = document.createElement('div');
        errorDiv.className = 'b2b-form-error';
        errorDiv.textContent = 'Form submission is not configured.';
        (submitBtn ? submitBtn.parentNode : formEl).appendChild(errorDiv);
        if (submitBtn) {
          submitBtn.disabled = false;
          submitBtn.textContent = originalBtnText;
        }
        return;
      }

      var iframeName = 'b2b-submit-iframe-' + Date.now();
      var iframe = document.createElement('iframe');
      iframe.name = iframeName;
      iframe.style.display = 'none';
      document.body.appendChild(iframe);

      formEl.target = iframeName;
      formEl.method = 'POST';

      var submitted = false;
      function onSuccess() {
        if (submitted) return;
        submitted = true;
        formEl.style.display = 'none';
        var successEl = document.getElementById(successElId);
        if (successEl) successEl.style.display = 'block';
        setTimeout(function() {
          if (iframe.parentNode) iframe.parentNode.removeChild(iframe);
        }, 1000);
      }
      iframe.addEventListener('load', onSuccess);
      formEl.submit();
    });
  }

  // Lead magnet form
  bindFormWithIframe(document.getElementById('b2b-leadmagnet-form'), 'b2b-leadmagnet-success');

  // --- Sticky mobile CTA reveal ---
  var stickyCta = document.querySelector('[data-sticky-cta]');
  if (stickyCta) {
    var heroSection = stickyCta.closest('section');
    var threshold = heroSection ? heroSection.offsetHeight * 0.75 : 400;
    var ticking = false;

    function updateSticky() {
      if (window.scrollY > threshold) {
        stickyCta.classList.add('b2b-sticky-cta-visible');
      } else {
        stickyCta.classList.remove('b2b-sticky-cta-visible');
      }
      ticking = false;
    }

    window.addEventListener('scroll', function() {
      if (!ticking) {
        window.requestAnimationFrame(updateSticky);
        ticking = true;
      }
    }, { passive: true });
  }
})();
